

<div class="margin-bottom-24">
    <div class="input-desc-label" style="margin-top:  8px;">{{'What method of calculation would you like to use for this tool ' | translate | async}}</div>
    <div style="margin-top: 8px;">
      <select class="select" [(ngModel)]="WornCalculationMethodTypeId" (change)="selectMethod($event.target.value)"  >
       
        <option value="1">STEPPED</option>
        <option value="2">Inflection</option>
        <option value="3">Polynomial</option>
        <option value="5" selected>Linear</option>
        <!-- <option value="6">JD</option>   JD is not implemented -->
      </select>
    </div>
  </div>

  <stepped-cal-method [hidden]="WornCalculationMethodTypeId != 1" #steppedCal     [steppedCalMethod]="steppedCalModel" ></stepped-cal-method>
  <inflection-cal-method [hidden]="WornCalculationMethodTypeId != 2" #inflectionCal  [inflectionCalMethod]= "inflectionCalModel"></inflection-cal-method>
  <ploynomial-cal-method [hidden]="WornCalculationMethodTypeId != 3" #ployCal  [ployCalModel]="ployCalModel"></ploynomial-cal-method>
  <linear-cal-method [hidden]="WornCalculationMethodTypeId != 5" #linearCal   [linearCalModel]="linearCalModel"></linear-cal-method>
  <jd-cal-method  [hidden]="WornCalculationMethodTypeId != 6" #jdCal  [jdCalMethod]= "jdCalModel"></jd-cal-method>
